import merge from 'lodash/merge';
import error from './error.js';
import login from './login.js';

var uz = {
  language: 'uz',
  country: 'uz',
  name: "O'zbek",
  embeddedLocale: merge(error, login),
  flags: ['UZ'],
};

export { uz as default };
